// need this for older tablets that don't support fetch :(
require('es6-promise').polyfill();
require('isomorphic-fetch');

import { getAPI, getAPIEncrypted } from 'global/js/helpers';
import { setUnsentSubmissionStatus } from 'containers/SubmissionStatus/actions';

const GET_DATA = 'GET_DATA';
const GET_DATA_ERROR = 'GET_DATA_ERROR';
const GET_EXPIRED_EVALUATION_ERROR = 'GET_EXPIRED_EVALUATION_ERROR';
const GET_DATA_RECEIVED = 'GET_DATA_RECEIVED';
const GET_ENCRYPTED_DATA_RECEIVED = 'GET_ENCRYPTED_DATA_RECEIVED';
const INTERNET_CONNECTION_ERROR = 'INTERNET_CONNECTION_ERROR';
const POST_DATA = 'POST_DATA';
const POST_DATA_ERROR = 'POST_DATA_ERROR';
const POST_DIRTY_DATA_ERROR = 'POST_DIRTY_DATA_ERROR';
const POST_DATA_RECEIVED = 'POST_DATA_RECEIVED';
const SET_LOCATION_STATUS = 'SET_LOCATION_STATUS';
const SET_LOCATION_INDEX = 'SET_LOCATION_INDEX';
const SET_OVERALL_STATUS = 'SET_OVERALL_STATUS';
const SET_USER_IDS = 'SET_USER_IDS';
const SET_ENCRYPTED_USER_IDS = 'SET_ENCRYPTED_USER_IDS';
const SET_ENCRYPTED_TOKEN = 'SET_ENCRYPTED_TOKEN';

/** 
 * @Deprecated
 *
 * Creates our GET request for the API and sets the relevant data when
 * it returns or fails.
 *
 * @param {Integer} prodTourID
 * @param {Integer} individualID
 */
export const fetchSurveyData = (prodTourID, individualID) => {
    // Pass the dispatch method to the returned function so
    // it can dispatch other actions as needed. Thunk middleware
    // handles resolving this.
    return (dispatch) => {
        dispatch(getData());

        // return the promise to fetch the survey data
        return fetch(getAPI('', {prodTourID, individualID}), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(
            (response) => {
                if (response.status === 200) {
                    return response.json();
                } else if(response.status === 410){
                    dispatch(getExpiredEvaluationError());
                    (error) => dispatch(getExpiredEvaluationError(error)) 
                } else {
                    dispatch(getDataError());

                    // Do not use catch, because that will also catch
                    // any errors in the dispatch and resulting render,
                    // causing a loop of 'Unexpected batch number' errors.
                    // Thanks to Dan Abramov for this ^^^^
                    (error) => dispatch(getDataError(error)) 
                }
            }, 
        )
        .then((data) => dispatch(getDataReceived(data)));
    };
};

/** 
 * Creates our GET request for the API using the encrypted backup survey data
 * and sets the relevant data when it returns or fails.
 *
 * @param {string} encryptedBackupSurveyParams
 * @param {string} token
 */
export const fetchSurveyDataEncrypted = (encryptedBackupSurveyParams, token) => {
    // Pass the dispatch method to the returned function so
    // it can dispatch other actions as needed. Thunk middleware
    // handles resolving this.
    return (dispatch) => {
        dispatch(getData());

        // return the promise to fetch the survey data
        return fetch(getAPIEncrypted(encryptedBackupSurveyParams, ''), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(
            (response) => {
                if (response.status === 200) {
                    return response.json();
                } else if(response.status === 410){
                    dispatch(getExpiredEvaluationError());
                    (error) => dispatch(getExpiredEvaluationError(error)) 
                } else {
                    dispatch(getDataError());

                    // Do not use catch, because that will also catch
                    // any errors in the dispatch and resulting render,
                    // causing a loop of 'Unexpected batch number' errors.
                    // Thanks to Dan Abramov for this ^^^^
                    (error) => dispatch(getDataError(error)) 
                }
            }
        )
        .then((data) => dispatch(getEncryptedDataReceived(data)));
    };
};
/**
 * Creates/Returns a function that gets the redux 'dispatch' function. This
 * returned function returns a recursive function (Yes, I have a headache).
 *
 * @param {Integer} prodID
 * @param {Integer} individualID
 * @param {Integer} newProdTourID
 * @param {Integer} newIndividualID
 * @param {String} endPoint
 * @param {Object} sendData
 * @param {Boolean} isDirty
 * @param {Boolean} isSubmit
 */
export const sendSurveyData = (
    prodTourID,
    individualID,
    newProdTourID,
    newIndividualID,
    endPoint,
    sendData,
    isDirty,
    isSubmit,
    token
) => {
    return (dispatch) => {
        dispatch(postData());

        return recursiveSend(
            dispatch,
            prodTourID,
            individualID,
            newProdTourID,
            newIndividualID,
            endPoint,
            sendData,
            isDirty,
            isSubmit,
            token,
            0
        );
    };
};

/**
 * Creates our PUT request for the API and sends the survey data. If the
 * isSubmit flag is true, then we attempt to post data <numTries> times
 * before throwing(dispatching) an error.
 *
 * @param {Function} dispatch
 * @param {Integer} prodID
 * @param {Integer} individualID
 * @param {Integer} newProdTourID
 * @param {Integer} newIndividualID
 * @param {String} endPoint
 * @param {Object} sendData
 * @param {Boolean} isDirty
 * @param {Boolean} isSubmit
 * @param {String} token
 * @param {Integer} numTries
 */
const recursiveSend = (
    dispatch,
    prodTourID,
    individualID,
    newProdTourID,
    newIndividualID,
    endPoint,
    sendData,
    isDirty,
    isSubmit,
    token,
    numTries
) => {
    // Our POST request.
    fetch(getAPI(endPoint, {prodTourID, individualID}), {
        method: 'put',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(sendData)
    })
    .then(
        (response) => {
            if (response.status === 200) {
                // Refetch the survey data after a successfull submit.
                if (isDirty) fetchData(dispatch, newProdTourID, newIndividualID);
                // Clear the old survey after a successfull submit.
                if (isSubmit) updateSubmissionStatusAfterSubmit(dispatch);
                // Update the state with the successful response.
                dispatch(postDataReceived(isSubmit));
            } else if (response.status === 500) {
                dispatch(postDataError(isSubmit));
            } else {
                sendHelper();
            }
        },
        () => sendHelper()
    );

    /**
     * Helper function to make recursive calls/checks.
     */
    const sendHelper = () => {
        if (numTries < 2 && isSubmit) {
            recursiveSend(
                dispatch,
                prodTourID,
                individualID,
                newProdTourID,
                newIndividualID,
                endPoint,
                sendData,
                isDirty,
                isSubmit,
                token,
                numTries + 1
            );
        } else {
            dispatch(postDirtyDataError(isSubmit));
        }
    };
};

/**
 * Clears out local storage and sets the user/prod ids before dispatching
 * the action to fetch our survey data.
 *
 * @param {Function} dispatch
 * @param {Integer} prodID
 * @param {Integer} individualID
 */
const fetchData = (dispatch, prodID, individualID) => {
    localStorage.clear();
    // Update the State with the user IDs
    dispatch(setUserIDs({
        individualID: individualID,
        prodTourID: prodID
    }));
    // Get our data!
    dispatch(fetchSurveyData(prodID, individualID));
};

/**
 * When the API request has been sent.
 */
export const getData = () => {
    return {
        type: GET_DATA
    };
};

/**
 * When a get request fails to return data.
 */
export const getDataError = (err) => {
    return {
        type: GET_DATA_ERROR,
        err
    };
};

export const getExpiredEvaluationError = (err) => {
    return {
        type: GET_EXPIRED_EVALUATION_ERROR,
        err
    };
};

/**
 * When the API request has been received.
 */
export const getDataReceived = (data) => {
    return {
        type: GET_DATA_RECEIVED,
        data
    };
};

/**
 * When the API request using encrypted data has been received.
 */
export const getEncryptedDataReceived = (data) => {
    return {
        type: GET_ENCRYPTED_DATA_RECEIVED,
        data
    };
};

/**
 * When there is no internet connection.
 */
export const internetConnectionError = (err) => {
    return {
        type: INTERNET_CONNECTION_ERROR,
        err
    };
};

/**
 * When we want to post changes back to the API.
 */
export const postData = () => {
    return {
        type: POST_DATA
    };
};

/**
 * When a post request fails to send data.
 */
export const postDataError = (isSubmit) => {
    return {
        type: POST_DATA_ERROR,
        isSubmit
    };
};

/**
 * When the API post has been received.
 */
export const postDataReceived = (isSubmit) => {
    return {
        type: POST_DATA_RECEIVED,
        isSubmit
    };
};

/**
 * When a post request fails to send 'dirty' data.
 */
export const postDirtyDataError = (isSubmit) => {
    return {
        type: POST_DIRTY_DATA_ERROR,
        isSubmit
    };
};

/**
 * When a location link is clicked.
 */
export const setLocationIndex = (index) => {
    return {
        type: SET_LOCATION_INDEX,
        index
    };
};

/**
 * When a location link is completed.
 */
export const setLocationStatus = (status) => {
    return {
        type: SET_LOCATION_STATUS,
        status
    };
};

/**
 * When an overall link is completed.
 */
export const setOverallStatus = (status) => {
    return {
        type: SET_OVERALL_STATUS,
        status
    };
};

/**
 * When there is a query string passed to the home component.
 */
export const setUserIDs = (ids) => {
    return {
        type: SET_USER_IDS,
        ids
    };
};

/**
 * When there is a encrypted query string passed to the home component.
 */
export const setEncryptedUserIDs = (ids) => {
    return {
        type: SET_ENCRYPTED_USER_IDS,
        ids
    };
};

/**
 * When there is a encrypted query string token passed to the home component.
 */
export const setEncryptedToken = (token) => {
    return {
        type: SET_ENCRYPTED_TOKEN,
        token
    };
};

/**
 * Updates the state and local storage after a successful submit.
 *
 * @param {Function} dispatch
 */
const updateSubmissionStatusAfterSubmit = (dispatch) => {
    localStorage.clear();
    dispatch(setUnsentSubmissionStatus(false));
};



// WEBPACK FOOTER //
// ./application/containers/Home/actions.js